import paths from 'routes/paths';
import { clearActingProducer, setActingProducerId } from 'helpers/actingProducer';
import { firstAllowedPanelPath, PERMISSIONS } from 'helpers/panelPermissions';
import { actorHasOwnPanel } from 'helpers/dashboardAccess';

/**
 * Entra no painel de um produtor como membro da equipe. A página recarrega de
 * propósito: o painel precisa subir já falando em nome do produtor, e não
 * misturar o usuário carregado antes com o que a API devolve agora.
 *
 * Por padrão cai na primeira página que as permissões abrem. Com `preferEvents`
 * (convite recém-aceito) cai na lista de eventos, quando a equipe liberou ver
 * eventos.
 *
 * @param {{ producer_id: number|string, permissions: string[] }} access
 * @param {{ preferEvents?: boolean }} [options]
 */
export function enterProducerPanel(access, { preferEvents = false } = {}) {
    setActingProducerId(access.producer_id);

    const seesEvents = (access.permissions || []).includes(PERMISSIONS.EVENTS_VIEW);
    const landing = preferEvents && seesEvents
        ? paths.dashboard.events
        : firstAllowedPanelPath(access.permissions);

    window.location.assign(landing || paths.dashboard.support);
}

/**
 * Abre a lista de eventos do painel do produtor como a própria pessoa: é a
 * entrada de quem foi convidado só para eventos (convite direto ou equipe sem
 * painel). Recarrega pelo mesmo motivo de `enterProducerPanel`: se a pessoa
 * estava dentro do painel de outro produtor, sai dele.
 */
export function openEventsPanel() {
    clearActingProducer();

    window.location.assign(paths.dashboard.events);
}

export function leaveProducerPanel() {
    clearActingProducer();

    window.location.assign(paths.events.home);
}

/**
 * Volta para o painel do próprio produtor, saindo do painel de outro. A página
 * recarrega pelo mesmo motivo de `enterProducerPanel`.
 */
export function openOwnPanel() {
    clearActingProducer();

    window.location.assign(paths.dashboard.statistics);
}

/**
 * Sai do painel de outro produtor: quem tem painel próprio volta para ele,
 * quem não tem volta para o site.
 */
export function leaveToOwnContext(user) {
    if (actorHasOwnPanel(user)) {
        openOwnPanel();
        return;
    }

    leaveProducerPanel();
}
